import React, { FC, useContext, useEffect, useState } from 'react'
import { Container } from '../components'
import { GuestContext } from '../Guest.context'
import NotFound from '@views/404/NotFound.component'
import RegisterForm from '@components/RegisterForm/RegisterForm.component'
import { useCreateUser } from '@hooks/useCreateUser'
import { useLogin } from '@hooks/useAuth'
import { NotificationType } from '@customTypes/notification.enum'
import RegisterNotifications from '@components/RegisterForm/RegisterNotifications'
import { useSetupGuestContext, useCustomerAPI } from '../hooks'
import { LinkContainer, Subtitle } from './GuestRegistration.style'
import Link from '@components/Link/Link.component'
import { guestRoute } from '../route'
import { useTranslation } from 'react-i18next'

export const GuestRegistration: FC = () => {
    // TODO: remove
    useSetupGuestContext()
    const { preflightData, formData, applyWhiteList } = useContext(GuestContext)
    const [loading, setLoading] = useState(false)
    const [showNotification, setShowNotification] = useState<NotificationType | null>(null)
    const { createUser } = useCreateUser()
    const login = useLogin()
    const { t } = useTranslation()

    const onRegisterClick = async (email: string, password: string, first_name: string, last_name: string) => {
        setLoading(true)

        try {
            const created = await createUser({
                first_name,
                last_name,
                email,
                password
            })

            if (created.data?.booking_create_user?.success) {
                // TODO save vehicle?

                await login(email, password, history, true)
                applyWhiteList()
            }
        } catch (error: any) {
            const code = error?.graphQLErrors[0]?.extensions?.code
            if (code === 409) {
                setShowNotification(NotificationType.EMAIL_EXISTS_ERROR)
            } else {
                setShowNotification(NotificationType.NEGATIVE)
            }
        }

        setLoading(false)
    }

    if (!preflightData || !formData) {
        return <NotFound />
    }

    return (
        <Container>
            <RegisterForm
                loading={loading}
                onRegisterClick={onRegisterClick}
                setLoading={setLoading}
                loginReturnUrl={guestRoute()}
                subtitle={<Subtitle>{t('guest.registrationSubtitle')}</Subtitle>}
            />
            <LinkContainer>
                <Link onClick={applyWhiteList}>{t('guest.continueAsGuest')}</Link>
            </LinkContainer>
            <RegisterNotifications notification={showNotification} />
        </Container>
    )
}
